import { Language } from '../types'

// Common ingredient translations
const INGREDIENT_TRANSLATIONS: Record<string, Record<Language, string>> = {
  // Dairy
  Vollmilch: {
    de: 'Vollmilch',
    en: 'Whole milk',
    fr: 'Lait entier',
    es: 'Leche entera',
    it: 'Latte intero',
    ar: 'حليب كامل الدسم',
  },
  Milch: {
    de: 'Milch',
    en: 'Milk',
    fr: 'Lait',
    es: 'Leche',
    it: 'Latte',
    ar: 'حليب',
  },
  Butter: {
    de: 'Butter',
    en: 'Butter',
    fr: 'Beurre',
    es: 'Mantequilla',
    it: 'Burro',
    ar: 'زبدة',
  },
  Sahne: {
    de: 'Sahne',
    en: 'Cream',
    fr: 'Crème',
    es: 'Nata',
    it: 'Panna',
    ar: 'كريمة',
  },
  Käse: {
    de: 'Käse',
    en: 'Cheese',
    fr: 'Fromage',
    es: 'Queso',
    it: 'Formaggio',
    ar: 'جبن',
  },
  Joghurt: {
    de: 'Joghurt',
    en: 'Yogurt',
    fr: 'Yaourt',
    es: 'Yogur',
    it: 'Yogurt',
    ar: 'زبادي',
  },
  Quark: {
    de: 'Quark',
    en: 'Curd cheese',
    fr: 'Fromage blanc',
    es: 'Requesón',
    it: 'Quark',
    ar: 'جبن قريش',
  },
  Molke: {
    de: 'Molke',
    en: 'Whey',
    fr: 'Lactosérum',
    es: 'Suero',
    it: 'Siero',
    ar: 'مصل اللبن',
  },

  // Basic ingredients
  Lab: {
    de: 'Lab',
    en: 'Rennet',
    fr: 'Présure',
    es: 'Cuajo',
    it: 'Caglio',
    ar: 'منفحة',
  },
  Salz: {
    de: 'Salz',
    en: 'Salt',
    fr: 'Sel',
    es: 'Sal',
    it: 'Sale',
    ar: 'ملح',
  },
  Zucker: {
    de: 'Zucker',
    en: 'Sugar',
    fr: 'Sucre',
    es: 'Azúcar',
    it: 'Zucchero',
    ar: 'سكر',
  },
  Bakterienkulturen: {
    de: 'Bakterienkulturen',
    en: 'Bacterial cultures',
    fr: 'Cultures bactériennes',
    es: 'Cultivos bacterianos',
    it: 'Culture batteriche',
    ar: 'مزارع بكتيرية',
  },
  Pfeffer: {
    de: 'Pfeffer',
    en: 'Pepper',
    fr: 'Poivre',
    es: 'Pimienta',
    it: 'Pepe',
    ar: 'فلفل',
  },
  Paprika: {
    de: 'Paprika',
    en: 'Paprika',
    fr: 'Paprika',
    es: 'Pimentón',
    it: 'Paprika',
    ar: 'فلفل حلو',
  },
  Knoblauch: {
    de: 'Knoblauch',
    en: 'Garlic',
    fr: 'Ail',
    es: 'Ajo',
    it: 'Aglio',
    ar: 'ثوم',
  },
  Zwiebel: {
    de: 'Zwiebel',
    en: 'Onion',
    fr: 'Oignon',
    es: 'Cebolla',
    it: 'Cipolla',
    ar: 'بصل',
  },

  // Condiments & Sauces
  Senf: {
    de: 'Senf',
    en: 'Mustard',
    fr: 'Moutarde',
    es: 'Mostaza',
    it: 'Senape',
    ar: 'خردل',
  },
  Mayonnaise: {
    de: 'Mayonnaise',
    en: 'Mayonnaise',
    fr: 'Mayonnaise',
    es: 'Mayonesa',
    it: 'Maionese',
    ar: 'مايونيز',
  },
  Ketchup: {
    de: 'Ketchup',
    en: 'Ketchup',
    fr: 'Ketchup',
    es: 'Ketchup',
    it: 'Ketchup',
    ar: 'كاتشب',
  },
  Essig: {
    de: 'Essig',
    en: 'Vinegar',
    fr: 'Vinaigre',
    es: 'Vinagre',
    it: 'Aceto',
    ar: 'خل',
  },
  Sojasauce: {
    de: 'Sojasauce',
    en: 'Soy sauce',
    fr: 'Sauce soja',
    es: 'Salsa de soja',
    it: 'Salsa di soia',
    ar: 'صلصة الصويا',
  },

  // Flour and grains
  Mehl: {
    de: 'Mehl',
    en: 'Flour',
    fr: 'Farine',
    es: 'Harina',
    it: 'Farina',
    ar: 'دقيق',
  },
  Weizenmehl: {
    de: 'Weizenmehl',
    en: 'Wheat flour',
    fr: 'Farine de blé',
    es: 'Harina de trigo',
    it: 'Farina di grano',
    ar: 'دقيق القمح',
  },
  Roggenmehl: {
    de: 'Roggenmehl',
    en: 'Rye flour',
    fr: 'Farine de seigle',
    es: 'Harina de centeno',
    it: 'Farina di segale',
    ar: 'دقيق الجاودار',
  },
  Dinkelmehl: {
    de: 'Dinkelmehl',
    en: 'Spelt flour',
    fr: "Farine d'épeautre",
    es: 'Harina de espelta',
    it: 'Farina di farro',
    ar: 'دقيق الحنطة',
  },
  Haferflocken: {
    de: 'Haferflocken',
    en: 'Oat flakes',
    fr: "Flocons d'avoine",
    es: 'Copos de avena',
    it: "Fiocchi d'avena",
    ar: 'رقائق الشوفان',
  },
  Reis: {
    de: 'Reis',
    en: 'Rice',
    fr: 'Riz',
    es: 'Arroz',
    it: 'Riso',
    ar: 'أرز',
  },

  // Eggs
  Eier: {
    de: 'Eier',
    en: 'Eggs',
    fr: 'Œufs',
    es: 'Huevos',
    it: 'Uova',
    ar: 'بيض',
  },
  Eigelb: {
    de: 'Eigelb',
    en: 'Egg yolk',
    fr: "Jaune d'œuf",
    es: 'Yema de huevo',
    it: "Tuorlo d'uovo",
    ar: 'صفار البيض',
  },
  Eiweiß: {
    de: 'Eiweiß',
    en: 'Egg white',
    fr: "Blanc d'œuf",
    es: 'Clara de huevo',
    it: 'Albume',
    ar: 'بياض البيض',
  },

  // Nuts & Seeds
  Erdnüsse: {
    de: 'Erdnüsse',
    en: 'Peanuts',
    fr: 'Cacahuètes',
    es: 'Cacahuetes',
    it: 'Arachidi',
    ar: 'فول سوداني',
  },
  Mandeln: {
    de: 'Mandeln',
    en: 'Almonds',
    fr: 'Amandes',
    es: 'Almendras',
    it: 'Mandorle',
    ar: 'لوز',
  },
  Haselnüsse: {
    de: 'Haselnüsse',
    en: 'Hazelnuts',
    fr: 'Noisettes',
    es: 'Avellanas',
    it: 'Nocciole',
    ar: 'بندق',
  },
  Walnüsse: {
    de: 'Walnüsse',
    en: 'Walnuts',
    fr: 'Noix',
    es: 'Nueces',
    it: 'Noci',
    ar: 'جوز',
  },
  Cashewnüsse: {
    de: 'Cashewnüsse',
    en: 'Cashews',
    fr: 'Noix de cajou',
    es: 'Anacardos',
    it: 'Anacardi',
    ar: 'كاجو',
  },
  Sesam: {
    de: 'Sesam',
    en: 'Sesame',
    fr: 'Sésame',
    es: 'Sésamo',
    it: 'Sesamo',
    ar: 'سمسم',
  },
  Sonnenblumenkerne: {
    de: 'Sonnenblumenkerne',
    en: 'Sunflower seeds',
    fr: 'Graines de tournesol',
    es: 'Semillas de girasol',
    it: 'Semi di girasole',
    ar: 'بذور عباد الشمس',
  },

  // Vegetables & Fruits
  Tomaten: {
    de: 'Tomaten',
    en: 'Tomatoes',
    fr: 'Tomates',
    es: 'Tomates',
    it: 'Pomodori',
    ar: 'طماطم',
  },
  Gurken: {
    de: 'Gurken',
    en: 'Cucumbers',
    fr: 'Concombres',
    es: 'Pepinos',
    it: 'Cetrioli',
    ar: 'خيار',
  },
  Karotten: {
    de: 'Karotten',
    en: 'Carrots',
    fr: 'Carottes',
    es: 'Zanahorias',
    it: 'Carote',
    ar: 'جزر',
  },
  Kartoffeln: {
    de: 'Kartoffeln',
    en: 'Potatoes',
    fr: 'Pommes de terre',
    es: 'Patatas',
    it: 'Patate',
    ar: 'بطاطس',
  },
  Äpfel: {
    de: 'Äpfel',
    en: 'Apples',
    fr: 'Pommes',
    es: 'Manzanas',
    it: 'Mele',
    ar: 'تفاح',
  },
  Zitronen: {
    de: 'Zitronen',
    en: 'Lemons',
    fr: 'Citrons',
    es: 'Limones',
    it: 'Limoni',
    ar: 'ليمون',
  },

  // Meat & Fish
  Rindfleisch: {
    de: 'Rindfleisch',
    en: 'Beef',
    fr: 'Bœuf',
    es: 'Carne de res',
    it: 'Manzo',
    ar: 'لحم بقر',
  },
  Schweinefleisch: {
    de: 'Schweinefleisch',
    en: 'Pork',
    fr: 'Porc',
    es: 'Cerdo',
    it: 'Maiale',
    ar: 'لحم خنزير',
  },
  Hühnerfleisch: {
    de: 'Hühnerfleisch',
    en: 'Chicken',
    fr: 'Poulet',
    es: 'Pollo',
    it: 'Pollo',
    ar: 'دجاج',
  },
  Fisch: {
    de: 'Fisch',
    en: 'Fish',
    fr: 'Poisson',
    es: 'Pescado',
    it: 'Pesce',
    ar: 'سمك',
  },
  Lachs: {
    de: 'Lachs',
    en: 'Salmon',
    fr: 'Saumon',
    es: 'Salmón',
    it: 'Salmone',
    ar: 'سلمون',
  },
  Thunfisch: {
    de: 'Thunfisch',
    en: 'Tuna',
    fr: 'Thon',
    es: 'Atún',
    it: 'Tonno',
    ar: 'تونة',
  },
  Garnelen: {
    de: 'Garnelen',
    en: 'Shrimp',
    fr: 'Crevettes',
    es: 'Gambas',
    it: 'Gamberetti',
    ar: 'جمبري',
  },

  // Other common ingredients
  Wasser: {
    de: 'Wasser',
    en: 'Water',
    fr: 'Eau',
    es: 'Agua',
    it: 'Acqua',
    ar: 'ماء',
  },
  Öl: {
    de: 'Öl',
    en: 'Oil',
    fr: 'Huile',
    es: 'Aceite',
    it: 'Olio',
    ar: 'زيت',
  },
  Olivenöl: {
    de: 'Olivenöl',
    en: 'Olive oil',
    fr: "Huile d'olive",
    es: 'Aceite de oliva',
    it: "Olio d'oliva",
    ar: 'زيت زيتون',
  },
  Sonnenblumenöl: {
    de: 'Sonnenblumenöl',
    en: 'Sunflower oil',
    fr: 'Huile de tournesol',
    es: 'Aceite de girasol',
    it: 'Olio di girasole',
    ar: 'زيت عباد الشمس',
  },
  Hefe: {
    de: 'Hefe',
    en: 'Yeast',
    fr: 'Levure',
    es: 'Levadura',
    it: 'Lievito',
    ar: 'خميرة',
  },
  Backpulver: {
    de: 'Backpulver',
    en: 'Baking powder',
    fr: 'Levure chimique',
    es: 'Levadura en polvo',
    it: 'Lievito in polvere',
    ar: 'بيكنج باودر',
  },
  Natron: {
    de: 'Natron',
    en: 'Baking soda',
    fr: 'Bicarbonate de soude',
    es: 'Bicarbonato',
    it: 'Bicarbonato',
    ar: 'بيكربونات الصوديوم',
  },
  Vanille: {
    de: 'Vanille',
    en: 'Vanilla',
    fr: 'Vanille',
    es: 'Vainilla',
    it: 'Vaniglia',
    ar: 'فانيليا',
  },
  Zimt: {
    de: 'Zimt',
    en: 'Cinnamon',
    fr: 'Cannelle',
    es: 'Canela',
    it: 'Cannella',
    ar: 'قرفة',
  },
  Kakao: {
    de: 'Kakao',
    en: 'Cocoa',
    fr: 'Cacao',
    es: 'Cacao',
    it: 'Cacao',
    ar: 'كاكاو',
  },
  Schokolade: {
    de: 'Schokolade',
    en: 'Chocolate',
    fr: 'Chocolat',
    es: 'Chocolate',
    it: 'Cioccolato',
    ar: 'شوكولاتة',
  },
  Honig: {
    de: 'Honig',
    en: 'Honey',
    fr: 'Miel',
    es: 'Miel',
    it: 'Miele',
    ar: 'عسل',
  },
  Gelatine: {
    de: 'Gelatine',
    en: 'Gelatin',
    fr: 'Gélatine',
    es: 'Gelatina',
    it: 'Gelatina',
    ar: 'جيلاتين',
  },
  Stärke: {
    de: 'Stärke',
    en: 'Starch',
    fr: 'Amidon',
    es: 'Almidón',
    it: 'Amido',
    ar: 'نشا',
  },
  Konservierungsstoffe: {
    de: 'Konservierungsstoffe',
    en: 'Preservatives',
    fr: 'Conservateurs',
    es: 'Conservantes',
    it: 'Conservanti',
    ar: 'مواد حافظة',
  },
  Farbstoffe: {
    de: 'Farbstoffe',
    en: 'Colorants',
    fr: 'Colorants',
    es: 'Colorantes',
    it: 'Coloranti',
    ar: 'ملونات',
  },
  Aromen: {
    de: 'Aromen',
    en: 'Flavors',
    fr: 'Arômes',
    es: 'Aromas',
    it: 'Aromi',
    ar: 'نكهات',
  },
  Verdickungsmittel: {
    de: 'Verdickungsmittel',
    en: 'Thickeners',
    fr: 'Épaississants',
    es: 'Espesantes',
    it: 'Addensanti',
    ar: 'مواد مثخنة',
  },
  Emulgatoren: {
    de: 'Emulgatoren',
    en: 'Emulsifiers',
    fr: 'Émulsifiants',
    es: 'Emulsionantes',
    it: 'Emulsionanti',
    ar: 'مستحلبات',
  },
}

// Common product name translations
const PRODUCT_TRANSLATIONS: Record<string, Record<Language, string>> = {
  'Gouda Käse': {
    de: 'Gouda Käse',
    en: 'Gouda Cheese',
    fr: 'Fromage Gouda',
    es: 'Queso Gouda',
    it: 'Formaggio Gouda',
    ar: 'جبن جودا',
  },
  Käse: {
    de: 'Käse',
    en: 'Cheese',
    fr: 'Fromage',
    es: 'Queso',
    it: 'Formaggio',
    ar: 'جبن',
  },
  Brot: {
    de: 'Brot',
    en: 'Bread',
    fr: 'Pain',
    es: 'Pan',
    it: 'Pane',
    ar: 'خبز',
  },
  Vollkornbrot: {
    de: 'Vollkornbrot',
    en: 'Whole grain bread',
    fr: 'Pain complet',
    es: 'Pan integral',
    it: 'Pane integrale',
    ar: 'خبز القمح الكامل',
  },
  Butter: {
    de: 'Butter',
    en: 'Butter',
    fr: 'Beurre',
    es: 'Mantequilla',
    it: 'Burro',
    ar: 'زبدة',
  },
  Joghurt: {
    de: 'Joghurt',
    en: 'Yogurt',
    fr: 'Yaourt',
    es: 'Yogur',
    it: 'Yogurt',
    ar: 'زبادي',
  },
  Wurst: {
    de: 'Wurst',
    en: 'Sausage',
    fr: 'Saucisse',
    es: 'Salchicha',
    it: 'Salsiccia',
    ar: 'نقانق',
  },
  Schinken: {
    de: 'Schinken',
    en: 'Ham',
    fr: 'Jambon',
    es: 'Jamón',
    it: 'Prosciutto',
    ar: 'لحم خنزير',
  },
}

export function translateIngredient(
  ingredientName: string,
  language: Language,
): string {
  // Try exact match first
  if (INGREDIENT_TRANSLATIONS[ingredientName]) {
    return INGREDIENT_TRANSLATIONS[ingredientName][language]
  }

  // Try case-insensitive match
  const lowerName = ingredientName.toLowerCase()
  const matchedKey = Object.keys(INGREDIENT_TRANSLATIONS).find(
    (key) => key.toLowerCase() === lowerName,
  )

  if (matchedKey) {
    return INGREDIENT_TRANSLATIONS[matchedKey][language]
  }

  // Return original if no translation found
  return ingredientName
}

export function translateProduct(
  productName: string,
  language: Language,
): string {
  // Try exact match first
  if (PRODUCT_TRANSLATIONS[productName]) {
    return PRODUCT_TRANSLATIONS[productName][language]
  }

  // Try case-insensitive match
  const lowerName = productName.toLowerCase()
  const matchedKey = Object.keys(PRODUCT_TRANSLATIONS).find(
    (key) => key.toLowerCase() === lowerName,
  )

  if (matchedKey) {
    return PRODUCT_TRANSLATIONS[matchedKey][language]
  }

  // Return original if no translation found
  return productName
}
